import { Component } from 'utils';
import { projectActions } from '../../../../store/reducers/projectReducer';

@Component({
    controllerAs: 'vm',
    template: require('./project-new.tpl.html'),
})
export class ProjectNewComponent {
    static $inject = ['$state', 'store'];

    constructor($state, store) {
        this._store = store;
        this._state = $state;
    }

    addProject() {
        this._store.dispatch({ type: projectActions.GET_NEW_PROJECT, payload: { projectType: 1 } })
            .then(() => this._state.go('app.authorized.projectWizard.settings', { id : 0,isNew: true }));
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/projects/project-new/project-new.js